import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home";
import FindLayouts from "../pages/FindLayouts";
import CustomizeLayout from "../pages/CustomizeLayout";

// Admin
import AdminLogin from "../admin/pages/AdminLogin";
import AdminMainlayout from "../admin/components/AdminMainlayout";
import Layouts from "../admin/pages/Layouts";


import RegisterPage from "../pages/Auth/RegisterPage";
import VerifyEmailAddress from "../pages/Auth/VerifyEmailAddress";
import Login from "../pages/Auth/Login";
import ResetPassword from "../pages/Auth/ResetPassword";

import UserProfile from "../pages/UserProfile";
import SubscriptionPage from "../pages/SubscriptionPage";
import CheckoutPage from "../pages/CheckoutPage";

import Coupons from "../admin/pages/Coupons";
import Subscriptions from "../admin/pages/Subscriptions";
import Pricings from "../admin/pages/Pricings";

const Allroutes = () => {
    return (
        <Router basename={'/slideez-ai'} >
            <Routes>
                <Route exact path="/" element={<MainLayout><Home /></MainLayout>} />
                <Route exact path="/find-layouts" element={<MainLayout><FindLayouts /></MainLayout>} />
                <Route exact path="/customize-layout/:id/:slug" element={<MainLayout><CustomizeLayout /></MainLayout>} />

                <Route exact path="/register" element={<MainLayout><RegisterPage /></MainLayout>} />
                <Route exact path="/verify-email-address" element={<MainLayout><VerifyEmailAddress /></MainLayout>} />
                <Route exact path="/login" element={<MainLayout><Login /></MainLayout>} />
                <Route exact path="/reset-password" element={<MainLayout><ResetPassword /></MainLayout>} />
                <Route exact path="/user-profile" element={<MainLayout><UserProfile /></MainLayout>} />
                <Route exact path="/subscription-list" element={<MainLayout><SubscriptionPage /></MainLayout>} />
                {/* <Route exact path="/checkout" element={<MainLayout><CheckoutPage /></MainLayout>} /> */}
                <Route exact path="/checkout/:id/:slug" element={<MainLayout><CheckoutPage /></MainLayout>} />



                <Route exact path="/admin" element={<AdminLogin />} />
                <Route exact path="/admin/login" element={<AdminLogin />} />

                <Route exact path="/admin/all-layouts" element={<AdminMainlayout title={"All Layouts"}><Layouts /></AdminMainlayout>} />
                <Route exact path="/admin/all-coupons" element={<AdminMainlayout title={"All Coupons"}><Coupons /></AdminMainlayout>} />
                <Route exact path="/admin/all-subscriptions" element={<AdminMainlayout title={"All Subscriptions"}><Subscriptions /></AdminMainlayout>} />
                <Route exact path="/admin/all-pricings" element={<AdminMainlayout title={"All Pricings"}><Pricings /></AdminMainlayout>} />

            </Routes>
        </Router>
    )
}

export default Allroutes;